/*
 * ELTERES — indicative FX display for international storefront.
 * ONLY changes visible storefront product prices; never modifies cart, payment,
 * product variants, JSON-LD, Shopify money formats, or the checkout currency (TRY).
 * Fixed display rates approved by merchant: 1 EUR = 60 TRY; 1 USD = 50 TRY.
 * Always round UP to the next multiple of five in the display currency.
 */
(() => {
  "use strict";
  const me = document.querySelector('script[data-elteres-fx-country]');
  const country = (me?.dataset.elteresFxCountry || '').toUpperCase();
  if (!country || country === 'TR') return;
  const eurozone = new Set('AT BE BG HR CY EE FI FR DE GR IE IT LV LT LU MT NL PT SK SI ES'.split(' '));
  const currency = eurozone.has(country) ? 'EUR' : 'USD';
  const selector = [
    '[data-product-price] [data-price-text]',
    '.product-price-group .money',
    '.product-price--regular .money',
    '.product-price--sale .money',
    '.product-card-basic__price .money',
    '.product-price-on-button',
    '.elh-product-card__price > span',
    '.elteres-sticky-cart__price'
  ].join(',');
  let rate = 0;
  let queued = false;
  let noticeAdded = false;
  const formatter = new Intl.NumberFormat(currency === 'EUR' ? 'en-IE' : 'en-US', {
    style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0
  });

  function parseTryCents(text) {
    const raw = (text || '').replace(/\u00a0/g, ' ').trim();
    if (!raw || /(?:EUR|USD|€|\$)/i.test(raw)) return null;
    const matches = raw.match(/\d[\d.,\s]*/g);
    if (!matches || matches.length !== 1) return null;
    let digits = matches[0].replace(/\s/g,'');
    const comma = digits.lastIndexOf(',');
    const dot = digits.lastIndexOf('.');
    const last = Math.max(comma, dot);
    const decimals = last !== -1 && digits.length - last - 1 === 2;
    if (decimals) digits = digits.substring(0,last).replace(/[.,]/g,'') + '.' + digits.substring(last+1);
    else digits = digits.replace(/[.,]/g,'');
    const value = Number(digits);
    return Number.isFinite(value) && value >= 0 ? Math.round(value*100) : null;
  }
  function convert(node) {
    if (!node.isConnected || node.closest('cart-drawer, .cart-drawer, .cart-items, form[action*="/cart"], .template-cart, [data-elteres-fx-ignore], [data-elteres-fx-note]')) return;
    if (node.children.length && !node.matches('[data-price-text], .elh-product-card__price > span')) return;
    const text = node.textContent.trim();
    if (!text || text === node.dataset.elteresFxConverted) return;
    const cents = parseTryCents(text);
    if (cents === null) return;
    const roundedUp = Math.ceil(((cents / 100 * rate) - 1e-9) / 5) * 5;
    const displayed = formatter.format(roundedUp);
    node.dataset.elteresFxConverted = displayed;
    node.dataset.elteresFxTryCents = String(cents);
    node.textContent = displayed;
  }
  function addNote() {
    if (noticeAdded) return;
    const price = document.querySelector('[data-product-price]');
    if (!price || !price.parentNode) return;
    if (document.querySelector('.elteres-fx-note')) {noticeAdded=true;return;}
    const note = document.createElement('span');
    note.className = 'elteres-fx-note';
    note.textContent = 'Indicative ' + currency + ' price · Payment in TRY at checkout';
    note.style.cssText = 'display:block;margin-top:5px;font-size:10px;line-height:1.4;letter-spacing:.015em;opacity:.7;';
    price.insertAdjacentElement('afterend', note);
    noticeAdded = true;
  }
  function updatePrices() {
    queued = false;
    if (!rate) return;
    document.querySelectorAll(selector).forEach(convert);
    addNote();
  }
  function schedule() {
    if (queued || !rate) return;
    queued = true;
    requestAnimationFrame(updatePrices);
  }
  function start(r) {
    if (!Number.isFinite(r) || r <= 0) return;
    rate = r;
    schedule();
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, {childList:true,characterData:true,subtree:true});
    if (window.eventBus && typeof window.eventBus.on === 'function') {
      window.eventBus.on('variant:updated', schedule);
      window.eventBus.on('variant:change', schedule);
    }
    document.addEventListener('shopify:section:load',schedule);
  }
  // Price conversion is display-only. Shopify checkout, cart and orders remain TRY.
  start(currency === 'EUR' ? 1 / 60 : 1 / 50);
})();